// Products general
export const selectProductsState = state => state.products;
export const selectProductsLoading = state => state.products.isLoading;
export const selectProductsError = state => state.products.error;

// Products
export const selectAllProducts = state => state.products.products;
